<div class='container-fluid' style="height:100%">
  <div class='row' style="height:100%" *ngIf="mode===0">
    <app-authentication (stateChange)="onStateChangedHandler($event)"></app-authentication>
  </div>
  <div class='row' style="height:100%" *ngIf="mode===2">
    <router-outlet></router-outlet>
    <!--<app-webpresenter></app-webpresenter>-->
  </div>
</div>
